import React, { Children, ReactNode } from "react";
import { Checkbox, Grid } from "@mui/material";
import { GridProp } from "./GridProps";

const Gridldn = (props: GridProp) => {
  return <Grid {...props} />;
};

export default Gridldn;
